module.exports = __webpack_public_path__ + "img/partially-impacted.ced61e39.svg";